import React, {FC, useEffect, useState} from 'react'
import {useFormik} from 'formik'
import {TextArea, TextInput} from '../../../../_metronic/partials'
import * as Yup from 'yup'
import {useStatusMessage} from '../../../features'
import {useParams} from 'react-router-dom'
import {KTSVG} from '../../../../_metronic/helpers'
import {Post} from '../../../../setup'
import {useNotifications} from '../../../@contexts'

const TO_RESPOND = process.env.REACT_APP_WEB_FORMS_TO_RESPOND || 'message-repondre'

interface ResponseFormInterface {
  administratorEmail: string;
  msg: string | null
  client: {
    id: number | undefined;
    email: string;
  }
}

interface initialValues {
  administratorEmail: string;
  clientEmail: string;
  message: string;
}


const validationSchema = Yup.object().shape({
  administratorEmail: Yup.string()
    .email('Format d\'e-mail incorrect')
    .min(12, 'Au moins 12 symboles')
    .max(50, 'Maximum 50 symboles')
    .required('e-mail est obligatoire'),
  clientEmail: Yup.string()
    .email('Format d\'e-mail incorrect')
    .min(12, 'Au moins 12 symboles')
    .max(50, 'Maximum 50 symboles')
    .required('e-mail est obligatoire'),
  message: Yup.string()
    .required('Message est obligatoire')
    .min(3, 'Maximum 50 symboles'),
})
const ResponseForm: FC<ResponseFormInterface> = ({administratorEmail, client, msg}) => {

  let {id}: {id: string} = useParams()
  const {formState, setLoading} = useStatusMessage()
  const [showResponseForm, setShowResponseForm] = useState<boolean>(false)
  const [responseMsg, setResponseMsg] = useState<string | null>(msg)
  const {setToast} = useNotifications()
  const endpoint = `${TO_RESPOND}/${id}?id_client=${client.id}`

  const onSubmit = async (values: initialValues, {setSubmitting}: {
    setSubmitting: (isSubmitting: boolean) => void
  }) => {
    setLoading(true)

    try {

      if (client.id && client.id > 0) {
        const response = await Post<any>(endpoint , values)
        setToast({type: 'success', text: {title: 'Politique de confidentialité', message: "----------"}})
        console.log(response)
        setResponseMsg(values.message)
        setTimeout(() => {
          setShowResponseForm(false);
        }, 1300);
      }


    } catch (err) {
      console.error('Error submitting the form:', err)
    } finally {
      setLoading(false)
      setSubmitting(false)
    }
  }

  const formik = useFormik({
    initialValues: {
      administratorEmail,
      clientEmail: client.email,
      message: '',
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit,
  })

  useEffect(() => {
    setResponseMsg(msg);
  }, [msg]);

  return (
    <>
      {
        responseMsg === null || responseMsg === ''
          ? <div id="kt_response_button"
                 className={'d-flex justify-content-end ' + (showResponseForm && 'd-none')}>
            <button className={`btn btn-sm btn-light-info`}
                    onClick={() => setShowResponseForm(true)}
            >
              Répondre
            </button>
          </div>
          : (
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-12 mb-2">
                <div
                  className="notice d-flex bg-light-primary rounded border-primary border border-dashed p-6">
                  <KTSVG
                    path="/media/icons/duotune/communication/com002.svg"
                    className="svg-icon-2tx svg-icon-primary me-4"
                  />
                  <div
                    className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                    <div className="mb-3 mb-md-0 fw-bold">
                      <h4 className="text-gray-800 fw-bolder">Votre reponse
                        :</h4>
                      <div className="fs-6 text-gray-600 pe-7">
                        {responseMsg}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
      }
      <div id="kt_response_edit"
           className={'flex-row-fluid ' + (!showResponseForm && 'd-none')}
      >
        <form onSubmit={formik.handleSubmit}
              id="kt_signin_change_email"
              className="form"
              noValidate
        >
          <div className="row">
            <div className="col-12 col-sm-6">
              <TextInput label={'E-mail Administrateur'} name={'administratorEmail'} formik={formik} flex={'column'} />
            </div>
            <div className="col-12 col-sm-6">
              <TextInput label={'E-mail Client'} name={'clientEmail'} formik={formik} flex={'column'} />
            </div>
            <div className="col-12">
              <TextArea label={'Message'} name={'message'} formik={formik} flex={'column'} cols={30} rows={7} />
            </div>
          </div>

          <div className="d-flex">
            <button id="kt_signin_submit"
                    type="submit"
                    className="btn btn-sm btn-primary  me-2"
                    disabled={formik.isSubmitting || !formik.isValid}
            >
              {!formState.loading && 'Répondre'}
              {formState.loading && (
                <span className="indicator-progress"
                      style={{display: 'block'}}>
                      S'il vous plaît, attendez...{' '}
                  <span className="spinner-border spinner-border-sm align-middle ms-2" />
                </span>
              )}
            </button>
            <button
              id="kt_signin_cancel"
              type="button"
              onClick={() => setShowResponseForm(false)}
              className="btn btn-sm btn-color-gray-400 btn-active-light-primary px-6"
            >
              Annuler
            </button>
          </div>
        </form>
      </div>
    </>
  )
}

export {ResponseForm}